import React from "react";
import Page, { PageProps } from "../Page";
import { Row, Col } from "antd";
import Header from "../../components/Header";
import { IPasswordResetPresenter } from "../../../presenter/authentication/PasswordResetPresenter";
import Title from "antd/es/typography/Title";
import Loader from "../../components/Loader";
import Text from "antd/lib/typography/Text";

export interface Props extends PageProps {}
export interface State extends IPasswordResetPresenter {}

export default class PasswordResetConfirmationPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { translate, loaders, confirmationMessage, confirmationSuccess } =
      this.state;

    return (
      <Page {...this.props}>
        <Header languagePickerVisible={true} />
        <div className="content-wrapper">
          <Title level={3} style={{ textAlign: "center" }}>
            {translate("pages.confirm_password_reset")}
          </Title>
          <Loader
            loading={loaders.confirmPasswordReset}
            children={
              <Row className={"modified-wrapper"}>
                <Col lg={15} sm={24} xs={24}>
                  <div className="content-container">
                    <div
                      className="content-section"
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                      }}>
                      <Text
                        className={
                          confirmationSuccess
                            ? "confirmation-success-message"
                            : "confirmation-error-message"
                        }>
                        {confirmationMessage}
                      </Text>
                    </div>
                  </div>
                </Col>
              </Row>
            }
          />
        </div>
      </Page>
    );
  }
}
